/**
 * 计算出当前时间和入参时间的相差天数、小时数、分钟数、秒数
 * @param time
 * @returns {{days: number, hours: number, minutes: number, seconds: number}}
 */
export function calDiff(time) {
  var date1 = time;  //开始时间
  var date2 = new Date();    //结束时间
  var date3 = date1 - date2.getTime();   //时间差的毫秒数
  //计算出相差天数
  var days = Math.floor(date3 / (24 * 3600 * 1000))
  var leave1 = date3 % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000)        //计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))
  //计算相差秒数
  var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)
  var text = `还剩<span>${days}</span>天<span>${hours}</span>小时<span>${minutes}</span>分钟<span>`
  return {days, hours, minutes, seconds}
}

export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}
//
// // 时间转换
// function timeForMat(count) {
//   // 拼接时间
//   const time1 = new Date()
//   const time2 = new Date()
//   if (count === 1) {
//     time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000))
//   } else {
//     if (count >= 0) {
//       time1.setTime(time1.getTime())
//     } else {
//       if (count === -2) {
//         time1.setTime(time1.getTime() + (24 * 60 * 60 * 1000) * 2)
//       } else {
//         time1.setTime(time1.getTime() + (24 * 60 * 60 * 1000))
//       }
//     }
//   }
//
//   const Y1 = time1.getFullYear()
//   const M1 = ((time1.getMonth() + 1) > 9 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
//   const D1 = (time1.getDate() > 9 ? time1.getDate() : '0' + time1.getDate())
//   const timer1 = Y1 + '-' + M1 + '-' + D1 + ' ' + '23:59:59' // 当前时间
//
//   time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * count))
//   const Y2 = time2.getFullYear()
//   const M2 = ((time2.getMonth() + 1) > 9 ? (time2.getMonth() + 1) : '0' + (time2.getMonth() + 1))
//   const D2 = (time2.getDate() > 9 ? time2.getDate() : '0' + time2.getDate())
//   const timer2 = Y2 + '-' + M2 + '-' + D2 + ' ' + '00:00:00' // 之前的7天或者30天
//   return [timer2, timer1]
// }
//
// export function days(num) {
//   const timer = timeForMat(num)
//   return timer
// }
//
// export function thirtyDays() {
//   // 获取最近30天
//   const timer = timeForMat(30)
//   return timer
// }
//
// // 获取最近7天
// export function sevenDays() {
//   // 获取最近7天
//   const timer = this.timeForMat(7)
//   return timer
// }
//
// export function yesterday() {
//   // 校验是不是选择的昨天
//   const timer = this.timeForMat(1)
//   return timer
// }
//
// export function today() {
//   const timer = this.timeForMat(0)
//   return timer
// }
//
// export function tomorrow() {
//   const timer = this.timeForMat(-1)
//   return timer
// }
//
// export function theDayAfterTomorrow() {
//   const timer = this.timeForMat(-2)
//   return timer
// }